var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"},[_c('h1',[_vm._v("Utloggningssida jobskills.se")]),_vm._v(" "),_c('p',[_vm._v("Du har ej blivit utloggad från Arbetsförmedlingen, för att göra det,\n    "),_c('a',{attrs:{"href":"https://arbetsformedlingen.se/logout"}},[_vm._v("klicka här")]),_vm._v(".\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23f8583e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/LoggedOut.vue
// module id = 788
// module chunks = 1